namespace GeniuzPOS.Inventory {
    export enum adjcodestatus {
        adjout = 1,
        adjin = 2
    }
    Serenity.Decorators.registerEnumType(adjcodestatus, 'GeniuzPOS.Inventory.adjcodestatus');
}
